import { urlsWrapper } from 'config';
import { createSelector } from 'reselect';
import { serialize } from 'utils';
import { commonGet, commonPut } from './api';
import {
  saveData,
  createCommonItemConstants,
  createCommonItemReducer,
  resetData,
  RESET_TYPES,
} from './utils';

const constants = createCommonItemConstants('FIELD');

// reducer
export default createCommonItemReducer(constants);

// actions
export function getField(fieldId, params) {
  return saveData(
    `${urlsWrapper('fields')}/${fieldId}${
      params ? `?${serialize(params)}` : ''
    }`,
    constants.SET_ITEM,
    constants.SET_IS_PENDING
  );
}

export function getFieldGeometries(fieldId, params) {
  const queryString = params ? `?${serialize(params)}` : '';
  return commonGet({
    url: `${urlsWrapper('fields')}/${fieldId}/geometries${queryString}`,
  }).catch((error) => {
    // eslint-disable-next-line no-console
    console.error(error);
    return [];
  });
}

export function updateFieldGeometries(fieldId, data) {
  return commonPut({
    url: `${urlsWrapper('fields')}/${fieldId}/geometries`,
    data,
    name: 'контуры поля',
  });
}

export function getGeoData() {
  return commonGet({
    url: urlsWrapper('geoTrackers'),
  });
}

export function getMachineData(sourceId, serial) {
  return commonGet({
    url: `${urlsWrapper('geoTrackersMachines')}/${sourceId}/${serial}`,
  });
}

export function resetField() {
  return resetData(constants.SET_ITEM, RESET_TYPES.ITEM);
}

// selectors
export const getFieldSelector = createSelector(
  [(state) => state.field.item, (state) => state.field.isPending],
  (item, isPending) => ({
    item,
    isPending,
  })
);
